export default __webpack_public_path__ + "static/media/img-0468-bulgaria-full-face.d6388e54.png";